<template lang="pug">
AuthLayout
    GlobalEvents(
      v-if="!isLoading && !$v.$error",
      @keyup.enter="login",
    )
    form
      section.login
        h2.o-heading {{ $t('common.login') }}
        p.fs-14.c-red.mt-4.mb-3 {{ error }}
        LabeledInput.mb-3(
          type="email",
          id="email",
          :label="$t('common.email')",
          :placeholder="$t('forms.enter_your_email')",
          :disabled="isLoading",
          :error="$v.credentials.email.$error",
          v-model="credentials.email",
          @input="clear",
          autocomplete="email",
        )
        LabeledInput.mb-4(
          type="password",
          id="password",
          :label="$t('common.password')",
          :placeholder="$t('forms.login.enter_your_password')",
          :disabled="isLoading",
          :error="$v.credentials.password.$error",
          v-model="credentials.password",
          @input="clear",
        )
        button.o-btn.o-btn--primary.o-btn--chevron.mb-3(
          type="button",
          :disabled="isLoading || $v.$error",
          @click="login()",
        ) {{ $t('common.login') }}

        .login__or-divider.mb-3(v-if="showContinueWith")
          span {{ $t('common.or') }}
        button.s-btn.s-btn--facebook(
          v-if="showContinueWith",
          type="button",
          @click="OAuthFacebookLogin"
        ) 
          img(src="~assets/facebook.svg", alt="")
          span {{ $t('forms.login.continue_with_facebook') }}
        hr
        p.o-paragraph.mb-4
          | {{ $t('forms.login.having_troubles_logging_in') }}
          =" "
          router-link.o-link(:to="{ name: 'ResetPasswordForm', query: $route.query }") {{ $t('common.reset_password') }}
          | .
</template>

<script>
import NProgress from "nprogress";
import GlobalEvents from "vue-global-events";
// import config from "src/config";
import AuthLayout from "src/layouts/Auth/Auth";
import LabeledInput from "src/components/LabeledInput/LabeledInput";
import Api from "src/services/api";
import { required, email } from "vuelidate/lib/validators";
import { mapErrorMessages } from "src/utils/vuelidate";
import { provide } from "vue";

export default {
  components: {
    AuthLayout,
    LabeledInput,
    GlobalEvents
  },
  data() {
    return {
      isLoading: false,
      backendErrorCode: undefined,
      backendErrorMessage: undefined,
      showContinueWith: true,
      credentials: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapErrorMessages({
      emailErrors: [
        "credentials.email",
        {
          required: "errors.emailRequired",
          email: "errors.emailInvalidFormat"
        }
      ],
      passwordErrors: [
        "credentials.password",
        {
          required: "errors.passwordRequired"
        }
      ]
    }),
    backendErrors() {
      if (this.backendErrorMessage) {
        return [this.backendErrorMessage];
      }

      if (this.backendErrorCode) {
        return [this.$t(`errors.response_${this.backendErrorCode}`)];
      }

      return [];
    },
    error() {
      return [
        ...this.backendErrors,
        ...this.emailErrors,
        ...this.passwordErrors
      ][0];
    }
  },
  methods: {
    async OAuthFacebookLogin() {
      this.isLoading = true;
      try {
        const loc = window.location;
        const redirectUrl = `${loc.protocol}//${loc.host}/oauth/facebook/login`;

        let loginRedirectUrl = this.$route.query.redirect_url;
        if (!loginRedirectUrl) {
          loginRedirectUrl = `https://listing-studio.curaytor.com/`;
        }

        const authUrl = await Api.OAuthLoginStart({
          provider: "facebook",
          redirectUrl: redirectUrl,
          loginRedirectUrl: loginRedirectUrl
        });

        window.location.href = authUrl;
      } catch (err) {
        console.log(err);
        this.backendErrorCode = err.response.status;
      }
    },
    async login() {
      if (this.$v.$touch() || this.$v.$error) return null;

      NProgress.start();
      this.isLoading = true;

      try {
        const redirectUrl = await Api.auth({
          email: this.credentials.email,
          password: this.credentials.password,
          redirect_url: this.$route.query.redirect_url
        });

        // redirect
        window.location.href = redirectUrl;
      } catch (err) {
        console.log(err);
        this.backendErrorCode = err.response.status;

        if (
          typeof err.response.data != "undefined" &&
          typeof err.response.data.message != "undefined"
        ) {
          this.backendErrorMessage = err.response.data.message;
        } else {
          this.backendErrorMessage = err.response.status;
        }
      }
      this.isLoading = false;
      NProgress.done();
    },
    clear() {
      this.isLoading = false;
      this.backendErrorCode = undefined;
      this.backendErrorMessage = undefined;
    }
  },
  validations() {
    return {
      credentials: {
        email: { required, email },
        password: { required }
      }
    };
  }
};
</script>

<style src="./Login.sass" lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue